import { camelToKebab } from '../util/utils';

let client;

export const setClient = (newClient) => {
  client = newClient;
};

export const getVariation = (key, defaultValue) => {
  if (!client) {
    return defaultValue;
  }

  const kebabKey = camelToKebab(key);
  return client.variation(kebabKey, defaultValue);
};

export const getContext = () => {
  if (!client) return {};
  return client.getContext() ?? {};
};

export const identify = (context) => {
  if (!client) return;
  client.identify(context);
};
